<template>
	<div class="wrap">
		<myHead></myHead>
		<div class="wrap_body">
			<div class="center">
				<div class="ucenter_main">
					<ucMenu num="5"></ucMenu>
					<div class="right_con">
						<div class="record_list">
							<div class="record_title">
								<p class="fb">商品入库</p>
								<el-button type="primary" size="small" @click="showAddDialog">新增入库</el-button>
							</div>
							<div class="table_wrap">
								<el-table :data="recordList" style="width: 100%" stripe v-loading="loading">
									<el-table-column type="index" label="序号" width="50" align="center"></el-table-column>
									<el-table-column label="商品主图" width="80" align="center">
										<template slot-scope="scope">
											<el-image
												v-if="scope.row.product_img"
												:src="scope.row.product_img"
												fit="cover"
												style="width: 30px; height: 30px; cursor: pointer;border-radius: 5px;"
												@click="openImg(scope.row)"
											>
											</el-image>
											<span v-else>-</span>
										</template>
									</el-table-column>
									<el-table-column label="店铺" width="100" align="center">
										<template slot-scope="scope">
											<span>{{ scope.row.shop_name || '--' }}</span>
										</template>
									</el-table-column>
									<el-table-column label="商品ID" width="120" align="center">
										<template slot-scope="scope">
											<el-button
												type="text"
												size="mini"
												@click="copyProductId(scope.row.product_id)"
												style="color: red;width: 100px;white-space: break-spaces;text-align: left;"
												:title="'点击复制: ' + scope.row.product_id">
												{{ scope.row.product_id }}
											</el-button>
										</template>
									</el-table-column>
									
									<el-table-column prop="product_name" label="商品标题" min-width="150" align="left">
										<template slot-scope="scope">
											<p style="word-break: break-all;font-size: 12px;line-height: 14px;">{{ scope.row.product_name || '-' }}</p>
										</template>
									</el-table-column>
									<el-table-column label="销售价" width="100" align="center">
										<template slot-scope="scope">
											<span>￥{{ scope.row.sell_price || '0.00' }}</span>
										</template>
									</el-table-column>
									<el-table-column label="成本价" width="100" align="center">
										<template slot-scope="scope">
											<span v-if="scope.row.link_id === 0">￥{{ scope.row.cost_price || '0.00' }}</span>
											<span v-else>--</span>
										</template>
									</el-table-column>
									<el-table-column label="现货库存" width="100" align="center">
										<template slot-scope="scope">
											<span v-if="scope.row.link_id === 0">{{ scope.row.stock || 0 }}</span>
											<span v-else>--</span>
										</template>
									</el-table-column>
									<el-table-column label="待入库存" width="100" align="center">
										<template slot-scope="scope">
											<span v-if="scope.row.link_id === 0">{{ scope.row.wait_stock || 0 }}</span>
											<span v-else>--</span>
										</template>
									</el-table-column>
									<el-table-column label="操作" width="220" align="center" fixed="right" class="action-btn-group">
										<template slot-scope="scope">
											<template  v-if="scope.row.link_id === 0">
												<el-button size="mini" type="success" class="action-btn-compact" @click="viewRecord(scope.row)" >查看</el-button>
												<el-button size="mini" class="action-btn-compact" @click="linkProduct(scope.row)">关联商品</el-button>
												<el-button size="mini" type="primary" class="action-btn-compact" @click="addStock(scope.row)">新增</el-button>
												<el-button size="mini" type="danger" class="action-btn-compact" @click="clearStock(scope.row)">清仓</el-button>
											</template>
											<template v-else> 
												<el-button size="mini" type="success" class="action-btn-compact" @click="linkProductShow(scope.row)" >查看关联</el-button>
												<el-button size="mini" type="primary" class="action-btn-compact" @click="deleteStock(scope.row)">删除</el-button>
											</template>
											
										</template>
									</el-table-column>
								</el-table>
								<div class="pagination_wrap">
									<el-pagination
										@size-change="handleSizeChange"
										@current-change="handleCurrentChange"
										:current-page="currentPage"
										:page-sizes="[10, 20, 50, 100]"
										:page-size="pageSize"
										layout="total, sizes, prev, pager, next, jumper"
										:total="total">
									</el-pagination>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<!-- 新增入库弹窗 -->
		<el-dialog
			:title="isViewMode ? '查看入库信息' : '新增入库'"
			:visible.sync="addDialogVisible"
			width="1000px"
			:close-on-click-modal="false"
			@close="resetAddDialog">
			<div class="add_dialog_content">
				<div class="filter_line">
					<div class="filter_item">
						<el-select
							v-model="addForm.shopId"
							placeholder="请选择店铺"
							clearable
							filterable
							:disabled="isViewMode"
							style="width: 200px;">
							<el-option
								v-for="shop in shopList"
								:key="shop.shop_id"
								:label="shop.shop_name"
								:value="shop.shop_id">
							</el-option>
						</el-select>
					</div>
					<div class="filter_item">
						<el-input
							v-model="addForm.productId"
							placeholder="请输入商品ID"
							:disabled="isViewMode"
							style="width: 300px;">
							<el-button slot="append" icon="el-icon-search" @click="searchProduct" :disabled="isViewMode" :loading="syncProductIng"></el-button>
						</el-input>
					</div>
				</div>
				<div class="product-title-row" v-if="productName">商品标题：{{ productName || '-' }}</div>
				<div class="sku_table_wrap" v-if="skuTableData.length > 0">
					<el-table
						:data="skuTableData"
						style="width: 100%"
						border
						max-height="400"
						:span-method="objectSpanMethod">
						<el-table-column :label="addProductSpecTitles.spec1 || '规格1'" align="center" width="200">
							<template slot-scope="scope">
								<div class="color-cell-wrapper">
									<div class="color-name">{{ scope.row.color }}</div>
									<el-select
										v-model="scope.row.linkColor"
										placeholder="关联规格"
										clearable
										filterable
										:disabled="isViewMode"
										size="mini"
										style="width: 100%; margin-top: 5px;"
										@change="handleLinkColorChange(scope.row)">
										<el-option
											v-for="color in getAvailableColorOptions(scope.row.color)"
											:key="color"
											:label="color"
											:value="color">
										</el-option>
									</el-select>
								</div>
							</template>
						</el-table-column>
						<el-table-column :label="addProductSpecTitles.spec2 || '规格2'" prop="size" align="center">
							<template slot-scope="scope">
								<span>{{ scope.row.sizeWithWeight || scope.row.size }}</span>
							</template>
						</el-table-column>
						<el-table-column label="现货库存" prop="stock" align="center" width="80"></el-table-column>
						<el-table-column label="销售价" align="center" width="100">
							<template slot-scope="scope">
								<span>￥{{ scope.row.price || '0.00' }}</span>
							</template>
						</el-table-column>
						<el-table-column label="拿货价" align="center" width="150">
							<template slot-scope="scope">
								<el-input-number 
									v-model="scope.row.inputPrice" 
									:min="0" 
									:precision="2" 
									size="small" 
									controls-position="right" 
									placeholder="请输入" 
									:disabled="isViewMode || scope.row.isDisabled"
									style="width: 100px;">
								</el-input-number>
							</template>
						</el-table-column>
						<el-table-column label="新增库存" align="center" width="130">
							<template slot-scope="scope">
								<el-input-number
									v-model="scope.row.waitStock"
									:min="0"
									:precision="0"
									controls-position="right"
									size="small"
									:disabled="isViewMode || scope.row.isDisabled"
									style="width: 100px;">
								</el-input-number>
							</template>
						</el-table-column>
					</el-table>
				</div>
				<div v-else-if="addForm.productId && !searching && !syncProductIng" class="empty_tip">
					<el-empty description="暂无商品规格数据"></el-empty>
				</div>
				<div class="logistics_wrap">
					<span class="filter_label">物流单号：</span>
					<el-input
						v-model="addForm.logisticsNo"
						placeholder="请输入物流单号"
						:disabled="isViewMode"
						style="width: 300px;">
					</el-input>
				</div>
			</div>
			<span slot="footer" class="dialog-footer">
				<el-button @click="addDialogVisible = false">{{ isViewMode ? '关闭' : '取消' }}</el-button>
				<el-button v-if="!isViewMode" type="primary" @click="submitStockIn" :loading="submitting">提交</el-button>
			</span>
		</el-dialog>
		<!-- 关联商品弹窗 -->
		<el-dialog
			:title="isLinkViewMode ? '查看关联商品' : '关联商品'"
			:visible.sync="linkDialogVisible"
			width="1200px"
			:close-on-click-modal="false"
			@close="resetLinkDialog">
			<div class="link_dialog_content">
				<div class="filter_line">
					<div class="filter_item">
						<span class="filter_label">店铺：</span>
						<el-select
							v-model="linkForm.shopId"
							placeholder="请选择店铺"
							clearable
							filterable
							style="width: 200px;">
							<el-option
								v-for="shop in shopList"
								:key="shop.shop_id"
								:label="shop.shop_name"
								:value="shop.shop_id">
							</el-option>
						</el-select>
					</div>
					<div class="filter_item">
						<span class="filter_label">关联商品ID：</span>
						<el-input
							v-model="linkForm.productId"
							placeholder="请输入商品ID"
							style="width: 300px;">
							<el-button slot="append" icon="el-icon-search" @click="searchLinkProduct"></el-button>
						</el-input>
					</div>
				</div>
				<div style="display: flex;justify-content: space-between;">
					<div class="link_product_title_row" style="width: 40%" v-if="linkProductName">关联商品({{linkForm.productId}})：{{ linkProductName || '-' }}</div>
					<div class="link_product_title_row" style="width: 40%" v-if="currentProductName">库存商品({{linkForm.link_dd_goods_id}})：{{ currentProductName || '-' }}</div>
				</div>
				
				<div class="link_sku_table_wrap" v-if="currentSkuTableData.length > 0 && linkSkuTableData.length > 0">
					<el-table
						:data="linkSkuTableData"
						style="width: 100%"
						border
						max-height="400">
						<el-table-column label="关联商品规格" align="center" min-width="300">
							<template slot-scope="scope">
								<span class="sku_name_text">{{ scope.row.skuName }}</span>
							</template>
						</el-table-column>
						<el-table-column label="绑定当前库存规格" align="center" min-width="300">
							<template slot-scope="scope">
								<el-select
									v-model="scope.row.bindCurrentSkuId"
									placeholder="请选择当前库存规格"
									clearable
									filterable
									size="small"
									style="width: 100%;"
									@change="handleBindCurrentSkuChange(scope.$index, scope.row)">
									<el-option
										v-for="item in currentSkuTableData"
										:key="item.id"
										:label="item.skuName"
										:value="String(item.id)">
									</el-option>
								</el-select>
							</template>
						</el-table-column>
					</el-table>
				</div>
				<div v-else-if="linkForm.productId && !linkSearching && !syncProductIng" class="empty_tip">
					<el-empty description="请查询关联商品"></el-empty>
				</div>
			</div>
			<span slot="footer" class="dialog-footer">
				<el-button @click="linkDialogVisible = false">取消</el-button>
				<el-button type="primary" @click="submitLinkProduct" :loading="linkSubmitting">确定</el-button>
			</span>
		</el-dialog>
		<shopList ref="child"></shopList>
		<myFoot></myFoot>
	</div>
</template>

<script>
import Vue from 'vue';
import {
	mapActions,
	mapState
} from "vuex";
import myHead from '../../components/myHead/myhead';
import myFoot from '../../components/myFoot/myfoot';
import ucMenu from '../../components/ucenterMenu/ucmenu';
import shopList from '../../components/shopList/shopList';
import {getGoodsInfo} from "../../api/main/ucenter";

export default {
	name: "ucenterProductWarehouse",
	data() {
		return {
			// 记录列表
			recordList: [],
			// 分页数据
			currentPage: 1,
			pageSize: 10,
			total: 0,
			//店铺列表
			shopList: [],
			// 加载状态
			loading: false,
			// 新增入库弹窗
			addDialogVisible: false,
			// 新增入库表单
			addForm: {
				shopId: '',
				productId: '',
				logisticsNo: ''
			},
			// 商品规格列表
			skuList: [],
			// 表格数据（展平后的数据）
			skuTableData: [],
			// 查询商品中
			searching: false,
			// 提交中
			submitting: false,
			// 同步商品中
			syncProductIng: false,
			productName: '',
			// 是否是查看模式
			isViewMode: false,
			// 是否是查看模式
			isLinkViewMode: false,
			// 新增入库商品的规格标题（规格1、规格2）
			addProductSpecTitles: {
				spec1: '',
				spec2: ''
			},
			// 关联商品弹窗
			linkDialogVisible: false,
			// 关联商品表单
			linkForm: {
				shopId: '',
				productId: '',
				link_dd_goods_id: ''
			},
			// 当前商品的规格数据
			currentSkuTableData: [],
			// 关联商品的规格数据
			linkSkuTableData: [],
			// 当前商品信息
			currentProductInfo: null,
			// 关联商品名称
			linkProductName: '',
			// 查询关联商品中
			linkSearching: false,
			// 提交关联商品中
			linkSubmitting: false,
			// 当前商品的规格标题（规格1、规格2）
			currentProductSpecTitles: {
				spec1: '',
				spec2: ''
			},
			//当前商品标题
			currentProductName: '',
			// 关联商品的规格标题（规格1、规格2）
			linkProductSpecTitles: {
				spec1: '',
				spec2: ''
			},
		}
	},
	components: {
		myHead,
		myFoot,
		ucMenu, shopList
	},
	computed: {
		...mapState({})
	},
	created() {
		this.initMockData();
		this.loadRecordList();
	},
	methods: {
		...mapActions({
			getGoodsInfo: "ucenter/getGoodsInfo",
			getDdShopList: "ucenter/getDdShopList",
			getReadyStockList: "ucenter/getReadyStockList",
			addStockIn: "ucenter/addStockIn",
			addLinkStockIn: "ucenter/addLinkStockIn",
			doSyncDdProductInfo:"ucenter/doSyncDdProductInfo",
		}),
		// 初始化模拟数据
		initMockData() {
			// 模拟店铺列表
			let param = {limit: 100, page: 1}
			this.getDdShopList({
				data: param, success: (res) => {
					if (res.code === 200) {
						this.is_ph = true
						let arr = JSON.parse(JSON.stringify(res.data.list_data.data))
						for (let i in arr) {
							arr[i].is_select = true
						}
						this.shopList = arr
					} else {
						this.$message({message: res.msg, type: 'error',});
					}
				}
			})
		},
		// 加载记录列表
		loadRecordList() {
			this.loading = true;
			// 模拟接口延迟
			this.getReadyStockList({
				data: {
					page: this.currentPage,
					pageSize: this.pageSize
				},
				success: (res) => {
					if (res.code == 200) {
						this.recordList = res.data.list_data.data
						this.total = res.data.list_data.total
					}else {
						this.$message({message: res.msg, type: 'error',});
					}
					
					this.loading = false;

				}
			})
		},
		// 显示新增入库弹窗
		showAddDialog() {
			this.isViewMode = false;
			this.addDialogVisible = true;
		},
		searchProduct() {
			if (!this.addForm.productId) {
				this.$message.warning('请输入商品ID');
				return;
			}
			if (!this.addForm.shopId) {
				this.$message.warning('请先选择店铺');
				return;
			}
			this.searching = true;
			this.skuList = [];
			this.getGoodsInfo({
				data: {
					goods_id: this.addForm.productId,
					shop_id: this.addForm.shopId
				},
				success: (res) => {
					this.is_save = false;
					// 提取商品标题
					if (res.code === 200) {
						this.productName = res.data.name;
						this.addForm.logisticsNo = res.data.logistics_no;
						if (res.data.ddSku && res.data.ddSku.length > 0) {
							// 提取新增入库商品的规格标题
							this.addProductSpecTitles = this.extractSpecTitles(res.data.ddSku);
							const mockSkuData = this.convertDdSkuToMockSkuData(res.data.ddSku);
							this.flattenSkuData(mockSkuData);
						} else {
							// this.skuTableData = [];
							// this.addProductSpecTitles = { spec1: '', spec2: '' };
							this.syncProduct(this.addForm.productId,this.addForm.shopId,1)
						}
						// this.$message({message: res.msg, type: 'success'});
					} else {
						this.$message({message: res.msg, type: 'error'});
						this.addProductSpecTitles = { spec1: '', spec2: '' };
					}
					this.searching = false;
				}
			});
		},
		/**
		 * 提取规格标题（规格1、规格2的名称）
		 */
		extractSpecTitles(ddSku) {
			if (!ddSku || ddSku.length === 0) {
				return { spec1: '', spec2: '' };
			}
			
			// 从第一个SKU中提取规格键名
			const firstSku = ddSku[0];
			const specStr = firstSku.dd_spec_value || '';
			const specKeys = [];
			
			specStr.split(/[；;]+/).forEach(pair => {
				const [key] = pair.split(/[：:]+/).map(s => s && s.trim());
				if (key) {
					specKeys.push(key);
				}
			});
			
			return {
				spec1: specKeys[0] || '',
				spec2: specKeys[1] || ''
			};
		},
		/**
		 * 将后端返回的 ddSku 数据结构转为 mockSkuData 格式
		 * mockSkuData: [{ attr_one: '红色', sizes: [{ attr_two: 'M', ... }] }, ...]
		 */
		convertDdSkuToMockSkuData(ddSku) {
			const result = {};
			ddSku.forEach(item => {
				// 提取属性
				const specStr = item.dd_spec_value || '';
				const specs = {};
				specStr.split(/[；;]+/).forEach(pair => {
					const [key, value] = pair.split(/[：:]+/).map(s => s && s.trim());
					if (key && value) specs[key] = value;
				});
				const attr_one = specs['颜色分类'] || specs['颜色'] || specs['Color'] || specs['color'] || '';
				const attr_two = specs['尺码大小'] || specs['尺码'] || specs['Size'] || specs['size'] || '';
				if (!attr_one || !attr_two) return;
				if (!result[attr_one]) result[attr_one] = [];
				result[attr_one].push({
					attr_two,
					id: item.id,
					price: item.price,
					inputPrice: item.inputPrice,
					waitStock: item.waitStock,
					linkColor: item.linkColor,
					linkSkuId: item.linkSkuId,
					isDisabled: item.linkSkuId > 0,
					sku_id: item.sku_id,
					stock: item.stock || 0
				});
			});
			return Object.keys(result).map(attr_one => ({
				attr_one,
				sizes: result[attr_one]
			}));
		},
		// 展平一对多数据，兼容 attr_one, attr_two 格式
		flattenSkuData(data) {
			this.skuTableData = [];
			data.forEach(colorItem => {
				colorItem.sizes.forEach(sizeItem => {
					this.skuTableData.push({
						id: sizeItem.id,
						color: colorItem.attr_one, // 颜色分类
						size: sizeItem.attr_two,   // 尺码大小
						sizeWithWeight: sizeItem.attr_two, // 若今后有体重可以拼接使用
						stock: sizeItem.stock,
						price: sizeItem.price, // 销售价
						sku_id: sizeItem.sku_id,
						waitStock: sizeItem.waitStock,
						inputPrice: sizeItem.inputPrice, // 新增：用户输入的拿货价
						linkColor: sizeItem.linkColor, // 关联的颜色分类
						linkSkuId: sizeItem.linkSkuId, // 关联的规格sku_id（根据尺码匹配）
						isDisabled: sizeItem.linkSkuId > 0 // 是否禁用输入框
					});
				});
			});
		},
		// 表格合并单元格方法
		objectSpanMethod({row, column, rowIndex, columnIndex}) {
			// 只对颜色分类列进行合并
			if (columnIndex === 0) {
				// 找到当前颜色在第一行的索引
				let firstRowIndex = 0;
				for (let i = 0; i < this.skuTableData.length; i++) {
					if (this.skuTableData[i].color === row.color) {
						firstRowIndex = i;
						break;
					}
				}

				// 如果是第一行，返回行数和列数
				if (rowIndex === firstRowIndex) {
					// 计算该颜色有多少行
					const rowspan = this.skuTableData.filter(item => item.color === row.color).length;
					return {
						rowspan: rowspan,
						colspan: 1
					};
				} else {
					// 其他行不显示
					return {
						rowspan: 0,
						colspan: 0
					};
				}
			}
		},
		// 获取可用的颜色选项（排除当前颜色）
		getAvailableColorOptions(currentColor) {
			// 获取所有不同的颜色分类
			const allColors = [...new Set(this.skuTableData.map(item => item.color))];
			// 排除当前颜色
			return allColors.filter(color => color !== currentColor);
		},
		// 处理关联颜色选择变化
		handleLinkColorChange(currentRow) {
			const selectedColor = currentRow.linkColor;
			const currentColor = currentRow.color;
			
			// 同步当前颜色分类下所有行的linkColor值（因为单元格合并，需要保持一致）
			this.skuTableData.forEach(item => {
				if (item.color === currentColor) {
					item.linkColor = selectedColor;
				}
			});
			
			if (!selectedColor) {
				// 如果清空选择，恢复当前颜色分类下的所有行并清空linkSkuId
				this.skuTableData.forEach(item => {
					if (item.color === currentColor) {
						item.isDisabled = false;
						item.linkSkuId = '';
					}
				});
				return;
			}
			
			// 获取被关联颜色分类下的所有规格
			const linkedColorSkus = this.skuTableData.filter(item => item.color === selectedColor);
			
			// 选择下拉框后，禁用当前颜色分类下的所有行并清空值，同时根据尺码匹配设置linkSkuId
			this.skuTableData.forEach(item => {
				if (item.color === currentColor) {
					item.isDisabled = true;
					item.inputPrice = 0;
					item.waitStock = 0;
					
					// 根据尺码匹配，找到对应的sku_id
					const matchedSku = linkedColorSkus.find(linkedItem => linkedItem.size === item.size);
					if (matchedSku) {
						item.linkSkuId = matchedSku.id;
					} else {
						item.linkSkuId = '';
					}
				}
			});
		},
		// 重置新增入库弹窗
		resetAddDialog() {
			this.addForm = {
				shopId: '',
				productId: '',
				logisticsNo: ''
			};
			this.skuList = [];
			this.skuTableData = [];
			this.searching = false;
			this.submitting = false;
			this.productName = '';
			this.isViewMode = false;
			this.addProductSpecTitles = { spec1: '', spec2: '' };
			// 清空所有关联状态
			this.skuTableData.forEach(item => {
				item.linkColor = '';
				item.linkSkuId = '';
				item.isDisabled = false;
			});
		},
		// 关联商品
		linkProduct(row) {
			this.linkDialogVisible = true;
			this.currentProductInfo = row;
			this.isLinkViewMode = false;
			// 加载当前商品的规格数据
			this.loadCurrentProductSku(row);
		},
		// 关联商品-查看  
		linkProductShow(row) {
			this.linkDialogVisible = true;
			this.currentProductInfo = row.linkStock;
			// 加载当前商品的规格数据
			this.linkForm.shopId = row.shop_id || '';
			this.linkForm.productId = row.product_id;
			this.linkForm.link_dd_goods_id = row.link_dd_goods_id;
			this.linkSearching = true;
			this.isLinkViewMode = true;

			getGoodsInfo({
				shop_id: row.shop_id,
				goods_id: row.link_dd_goods_id
			}).then(res => {
				this.linkSearching = false;
				this.is_save = false;
				if (res.code === 200) {
					this.currentProductName = res.data.name;
					if (res.data.ddSku && res.data.ddSku.length > 0) {
						// 提取当前商品的规格标题
						this.currentProductSpecTitles = this.extractSpecTitles(res.data.ddSku);
						const mockSkuData = this.convertDdSkuToMockSkuData(res.data.ddSku);
						this.flattenSkuDataForLink(mockSkuData, 'current');
						// linkSkuId 已在 flattenSkuDataForLink 中初始化，无需再次设置
						this.searchLinkProduct()
					} else {
						this.currentSkuTableData = [];
						this.currentProductSpecTitles = { spec1: '', spec2: '' };
					}
				} else {
					this.$message({message: res.msg, type: 'error'});
					this.currentSkuTableData = [];
					this.currentProductSpecTitles = { spec1: '', spec2: '' };
				}
			}).catch(err => {
				this.linkSearching = false;
				this.$message.error('查询失败');
				this.currentSkuTableData = [];
				this.currentProductSpecTitles = { spec1: '', spec2: '' };
			});
		},
		// 加载当前商品的规格数据
		loadCurrentProductSku(row) {
			if (!row.product_id) {
				this.$message.warning('商品ID不存在');
				return;
			}
			this.linkForm.shopId = row.shop_id || '';
			this.linkForm.productId = '';
			this.linkForm.link_dd_goods_id = row.product_id;
			this.linkSearching = true;
			
			getGoodsInfo({
				shop_id: row.shop_id,
				goods_id: row.product_id
			}).then(res => {
				this.linkSearching = false;
				this.is_save = false;
				if (res.code === 200) {
					this.currentProductName = res.data.name;
					if (res.data.ddSku && res.data.ddSku.length > 0) {
						// 提取当前商品的规格标题
						this.currentProductSpecTitles = this.extractSpecTitles(res.data.ddSku);
						const mockSkuData = this.convertDdSkuToMockSkuData(res.data.ddSku);
						this.flattenSkuDataForLink(mockSkuData, 'current');
						// linkSkuId 已在 flattenSkuDataForLink 中初始化，无需再次设置
					} else {
						this.currentSkuTableData = [];
						this.currentProductSpecTitles = { spec1: '', spec2: '' };
					}
				} else {
					this.$message({message: res.msg, type: 'error'});
					this.currentSkuTableData = [];
					this.currentProductSpecTitles = { spec1: '', spec2: '' };
				}
			}).catch(err => {
				this.linkSearching = false;
				this.$message.error('查询失败');
				this.currentSkuTableData = [];
				this.currentProductSpecTitles = { spec1: '', spec2: '' };
			});
		},
		// 查询关联商品
		searchLinkProduct() {
			if (!this.linkForm.productId) {
				this.$message.warning('请输入商品ID');
				return;
			}
			if (!this.linkForm.shopId) {
				this.$message.warning('请选择店铺');
				return;
			}
			
			this.linkSearching = true;
			getGoodsInfo({
				shop_id: this.linkForm.shopId,
				goods_id: this.linkForm.productId
			}).then(res => {
				this.linkSearching = false;
				this.is_save = false;
				if (res.code === 200) {
					this.linkProductName = res.data.name;
					if (res.data.ddSku && res.data.ddSku.length > 0) {
						// 提取关联商品的规格标题
						this.linkProductSpecTitles = this.extractSpecTitles(res.data.ddSku);
						const mockSkuData = this.convertDdSkuToMockSkuData(res.data.ddSku);
						this.flattenSkuDataForLink(mockSkuData, 'link');
						// 不进行自动匹配，仅根据已有映射初始化绑定显示
						this.$nextTick(() => {
							this.initBindCurrentSkuId();
						});
					} else {
						// this.linkSkuTableData = [];
						// this.linkProductSpecTitles = { spec1: '', spec2: '' };
						this.syncProduct(this.linkForm.productId,this.linkForm.shopId,2)
					}
				} else {
					this.$message({message: res.msg, type: 'error'});
					this.linkSkuTableData = [];
					this.linkProductSpecTitles = { spec1: '', spec2: '' };
				}
			}).catch(err => {
				this.linkSearching = false;
				this.$message.error('查询失败');
				this.linkSkuTableData = [];
				this.linkProductSpecTitles = { spec1: '', spec2: '' };
			});
		},
		// 展平规格数据（用于关联商品）
		flattenSkuDataForLink(data, type) {
			const result = [];
			data.forEach(colorItem => {
				colorItem.sizes.forEach(sizeItem => {
					const skuName = `${colorItem.attr_one} - ${sizeItem.attr_two}`;
					const item = {
						id: sizeItem.id,
						color: colorItem.attr_one,
						size: sizeItem.attr_two,
						sizeWithWeight: sizeItem.attr_two,
						skuName: skuName, // 完整的规格名称
						stock: sizeItem.stock || 0, // 现货库存
						price: sizeItem.price, // 销售价
						inputPrice: sizeItem.inputPrice || 0, // 拿货价
						waitStock: sizeItem.waitStock || 0, // 待入库存
						sku_id: sizeItem.sku_id, // 保留原始类型，用于显示
						linkSkuId: sizeItem.linkSkuId ? String(sizeItem.linkSkuId) : '', // 统一使用字符串类型，确保匹配
					};
					// 如果是关联商品规格，添加绑定当前库存规格的字段
					if (type === 'link') {
						item.bindCurrentSkuId = ''; // 初始化绑定当前库存规格ID
					}
					result.push(item);
				});
			});
			if (type === 'current') {
				this.currentSkuTableData = result;
			} else {
				this.linkSkuTableData = result;
			}
		},
		// 自动匹配规格
		autoMatchSkus() {
			this.currentSkuTableData.forEach((currentItem, index) => {
				// 先尝试完全匹配：颜色和尺码都相同
				let matchedSku = this.linkSkuTableData.find(linkItem => 
					linkItem.color === currentItem.color && linkItem.size === currentItem.size
				);
				
				
				// 如果完全匹配失败，尝试只匹配尺码
				if (!matchedSku) {
					matchedSku = this.linkSkuTableData.find(linkItem => 
						linkItem.size === currentItem.size
					);
				}
				
				// 使用 $set 确保响应式更新，并确保类型一致（统一使用字符串）
				if (matchedSku) {
					this.$set(this.currentSkuTableData[index], 'linkSkuId', String(matchedSku.sku_id));
				} else {
					this.$set(this.currentSkuTableData[index], 'linkSkuId', '');
				}
			});
		},
		// 处理关联商品规格选择变化（旧方法，保留兼容）
		handleLinkSkuChange(index, row) {
			// 使用 $set 确保响应式更新，并确保类型一致（统一使用字符串）
			const linkSkuId = row.linkSkuId ? String(row.linkSkuId) : '';
			this.$set(this.currentSkuTableData[index], 'linkSkuId', linkSkuId);
		},
		// 初始化绑定关系（根据 currentSkuTableData 的 linkSkuId 反向设置 linkSkuTableData 的 bindCurrentSkuId）
		initBindCurrentSkuId() {
			this.linkSkuTableData.forEach((linkItem, index) => {
				this.$set(this.linkSkuTableData[index], 'bindCurrentSkuId', linkItem.linkSkuId);
			});
		},
		// 处理绑定当前库存规格变化（不做反向绑定）
		handleBindCurrentSkuChange(index, row) {
			const bindCurrentSkuId = row.bindCurrentSkuId ? String(row.bindCurrentSkuId) : '';
			this.$set(this.linkSkuTableData[index], 'bindCurrentSkuId', bindCurrentSkuId);
		},
		// 提交关联商品
		submitLinkProduct() {
			if (this.currentSkuTableData.length === 0) {
				this.$message.warning('当前商品没有规格数据');
				return;
			}
			if (this.linkSkuTableData.length === 0) {
				this.$message.warning('请先查询关联商品');
				return;
			}
			
			// 检查是否所有规格都已关联
			const unlinkedSkus = this.linkSkuTableData.filter(item => !item.linkSkuId);
			if (unlinkedSkus.length > 0) {
				this.$confirm(`有${unlinkedSkus.length}个规格未关联，确定要继续吗？`, '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					this.doSubmitLinkProduct();
				}).catch(() => {});
			} else {
				this.doSubmitLinkProduct();
			}
		},
		// 执行提交关联商品
		doSubmitLinkProduct() {
			// 这里应该调用关联商品的API
			// 需求：左列（关联商品规格）的 sku_id -> 右列选择的当前库存规格 bindCurrentSkuId 作为 link_sku_id
			const linkData = this.linkSkuTableData.map(item => ({
				sku_id: item.id,
				link_sku_id: item.bindCurrentSkuId || ''
			}));
			let params = {
				product_id: this.linkForm.productId,
				link_product_id: this.currentProductInfo.product_id,
				link_data: linkData
			};
			console.log('关联商品数据：', params);
			// this.$message.success('关联商品功能待实现，数据已打印到控制台');
			// TODO: 调用关联商品API
			this.linkSubmitting = true;
			this.addLinkStockIn({
				data: params,
				success: (res) => {
					if (res.code !== 200) {
						this.$message.error(res.msg);
						this.linkSubmitting = false;
						return;
					}
					this.$message.success('关联成功');
					this.linkDialogVisible = false;
					this.loadRecordList();
				},
				fail: (res) => {
				}
			})
		},
		// 重置关联商品弹窗
		resetLinkDialog() {
			this.linkForm = {
				shopId: '',
				productId: ''
			};
			this.currentSkuTableData = [];
			this.linkSkuTableData = [];
			this.currentProductInfo = null;
			this.linkProductName = '';
			this.linkSearching = false;
			this.linkSubmitting = false;
			this.currentProductSpecTitles = { spec1: '', spec2: '' };
			this.linkProductSpecTitles = { spec1: '', spec2: '' };
		},
		// 查看记录
		viewRecord(row) {
			this.isViewMode = true;
			this.addDialogVisible = true;
			this.addForm.productId = row.product_id || '';
			this.addForm.shopId = row.shop_id || '';
			// 如果有商品ID和店铺ID，自动查询商品信息
			if (this.addForm.productId && this.addForm.shopId) {
				this.searchProduct();
			}
		},
		// 新增库存
		addStock(row) {
			console.log('新增入库', row);
			this.isViewMode = false;
			this.addDialogVisible = true;
			this.addForm.productId = row.product_id || '';
			this.addForm.shopId = row.shop_id || '';
			this.searchProduct()
		},
		//同步抖店商品
		syncProduct(dd_goods_id,shop_id,type){
			this.syncProductIng = true
			this.doSyncDdProductInfo({data:{dd_goods_id:dd_goods_id,shop_id:shop_id},success:(res)=>{
					this.syncProductIng = false
					if(Number(res.code) === 200){
						if (type === 1) {
							this.searchProduct()
						}else{
							this.searchLinkProduct()
						}
					}else{
						this.$message({message: res.msg,type: 'error',})
					}
				}})
		},
		submitStockIn() {
			if (!this.addForm.shopId) {
				this.$message.warning('请选择店铺');
				return;
			}
			if (!this.addForm.productId) {
				this.$message.warning('请输入商品ID');
				return;
			}
			if (!this.addForm.logisticsNo) {
				this.$message.warning('请输入物流单号（必填）');
				return;
			}
			if (this.skuTableData.length === 0) {
				this.$message.warning('请先查询商品规格');
				return;
			}

			// 检查是否有新增库存
			const hasWaitStock = this.skuTableData.some(item => item.waitStock > 0);
			if (!hasWaitStock) {
				this.$message.warning('请至少输入一个规格的新增库存数量');
				return;
			}
			// 检查填写新增库存的规格是否填写拿货价
			let hasInputPrice = true;
			this.skuTableData.forEach(item => {
				if (item.waitStock > 0 && !item.inputPrice) {
					this.$message.warning(`请填写规格【${item.color}${item.size}】的拿货价`);
					hasInputPrice = false;
				}
			});
			
			if (!hasInputPrice) {
				console.log(this.skuTableData);
				return;
			}
			console.log(this.skuTableData);
			let params = {
				shop_id: this.addForm.shopId,
				product_id: this.addForm.productId,
				logistics_no: this.addForm.logisticsNo,
				sku_list: this.skuTableData.map(item => ({
						id: item.id,
						sku_id: item.sku_id,
						wait_stock: item.waitStock,
						input_price: item.inputPrice,
						link_color: item.linkColor || '', // 包含关联的颜色分类
						link_sku_id: item.linkSkuId || '' // 包含关联的规格sku_id（根据尺码匹配）
					}))
			};
			console.log(params);
			// return;
			this.submitting = true;
			
			this.addStockIn({
				data: params,
				success: (res) => {
					if (res.code !== 200) {
						this.$message.error(res.msg);
						this.submitting = false;
						return;
					}
					this.$message.success('提交成功');
					this.addDialogVisible = false;
					this.loadRecordList();
				},
				fail: (res) => {
				}
			})
		},
		// 清仓
		clearStock(row) {
			this.$confirm('确定要清空该商品的库存吗？', '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			}).then(() => {
				// 这里应该调用清仓API
				this.$message.success('清仓成功');
				this.loadRecordList();
			}).catch(() => {
				this.$message.info('已取消清仓');
			});
		},
		deleteStock(row){
			this.$confirm('确定要删除该商品的库存吗？', '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			}).then(() => {
				//删除时注意gyl_dd_ready_stock、gyl_dd_ready_stock_sku两个表的数据都要删除。不然有相同抖店skuid时可能取到已删除的数据
				this.$message.success('删除成功');
				this.loadRecordList();
			}).catch(() => {
				this.$message.info('已取消删除');
			});
		},
		openImg(row) {
			console.log(row)
			let htm = '<img style="object-fit: cover;margin-right: 10px;max-height:70vh;" src="' + row.product_img + '" alt="">'

			this.$alert(htm, row.product_name, {
				dangerouslyUseHTMLString: true,
				showClose: false,
				confirmButtonText: '关闭',
				closeOnClickModal: true,
				customClass: 'zdy-message-box'
			});
		},
		// 分页大小改变
		handleSizeChange(val) {
			this.pageSize = val;
			this.loadRecordList();
		},
		// 当前页改变
		handleCurrentChange(val) {
			this.currentPage = val;
			this.loadRecordList();
		},
		// 复制商品ID
		copyProductId(productId) {
			if (!productId) {
				this.$message.warning('商品ID为空');
				return;
			}

			// 创建临时文本区域元素
			const textArea = document.createElement('textarea');
			textArea.value = productId;
			document.body.appendChild(textArea);
			textArea.select();

			try {
				// 执行复制命令
				const successful = document.execCommand('copy');
				if (successful) {
					this.$message.success('商品ID已复制到剪贴板');
				} else {
					this.$message.error('复制失败，请手动复制');
				}
			} catch (err) {
				this.$message.error('复制失败，请手动复制');
			}

			// 清理临时元素
			document.body.removeChild(textArea);
		},
		// 复制店铺ID
		copyShopId(shopId) {
			if (!shopId) {
				this.$message.warning('店铺ID为空');
				return;
			}

			// 创建临时文本区域元素
			const textArea = document.createElement('textarea');
			textArea.value = shopId;
			document.body.appendChild(textArea);
			textArea.select();

			try {
				// 执行复制命令
				const successful = document.execCommand('copy');
				if (successful) {
					this.$message.success('店铺ID已复制到剪贴板');
				} else {
					this.$message.error('复制失败，请手动复制');
				}
			} catch (err) {
				this.$message.error('复制失败，请手动复制');
			}

			// 清理临时元素
			document.body.removeChild(textArea);
		},
	},
}
</script>

<style lang="less" scoped>
.wrap .wrap_body {
	display: flex;
	flex-direction: column;
}

.center {
	display: flex;
	flex: 1;
}

.ucenter_main {
	padding: 30px 0 40px;
	display: flex;
	justify-content: space-between;
	flex: 1;
}

.right_con {
	width: 980px;
}

.shangjia_main {
	padding: 36px 40px;
	background: #fff;
}

.opts_wrap {
	margin-left: 50px;
	padding-top: 14px;
}

.opts_wrap .opts_line {
	margin-top: 30px;
	display: flex;
	align-items: center;
}

.opts_line .txt {
	width: 140px;
	text-align: right;
	font-size: 14px;
}

.opts_line .txt.txt_check {
	display: flex;
	align-items: center;
	justify-content: space-between;
}

.opts_line .con {
	flex: 1;
	width: 0;
	margin-left: 22px;
	display: flex;
	align-items: center;
}

.opts_line .con .t {
	font-size: 14px;
}

.opts_wrap .btn_wrap {
	margin: 40px 0 0 112px;
	display: flex;
}

.opts_wrap .btn_wrap .btn {
	width: 80px;
	height: 34px;
	border-radius: 4px;
	display: flex;
	justify-content: center;
	align-items: center;
	margin-right: 14px;
	cursor: pointer;
	box-sizing: border-box;
	font-size: 14px;
}

.opts_wrap .btn_wrap .btn:nth-child(1) {
	background: var(--red);
	color: #fff;
}

.opts_wrap .btn_wrap .btn:nth-child(2) {
	background: #fff;
	color: #333;
	border: 1px solid #ddd;
}

.ml8 {
	margin-left: 8px;
}

.w80 {
	width: 80px;
}

.shop_list {
	width: auto;
}

.shop_list .shop_item {
	border-bottom: 1px solid #ededed;
	padding: 0 10px;
}


.record_list {
	padding: 36px 40px;
	background: #fff;

	.record_title {
		margin-bottom: 20px;
		display: flex;
		justify-content: space-between;
		align-items: center;

		.fb {
			margin: 0;
		}
	}

	.table_wrap {
		.pagination_wrap {
			margin-top: 20px;
			text-align: right;
		}

		// 操作列按钮不换行
		::v-deep .el-table__body-wrapper {
			.el-table__body {
				td {
					white-space: nowrap;
					.cell{
						
					}
				}
			}
		}

		// 操作按钮紧凑样式
		::v-deep .action-btn-compact {
			font-size: 12px;
			padding: 4px 6px;
			margin: 0 1px;
			line-height: 1.2;

			&.el-button--mini {
				padding: 4px 6px;
				font-size: 12px;
				line-height: 1.2;
			}
		}
	}
}

// 新增入库弹窗样式
.add_dialog_content {
	.filter_line {
		display: flex;
		align-items: center;
		gap: 20px;
		margin-bottom: 20px;

		.filter_item {
			display: flex;
			align-items: center;

			.filter_label {
				font-size: 14px;
				color: #333;
				margin-right: 10px;
				white-space: nowrap;
			}
		}
	}

	.product-title-row {
		margin-bottom: 20px;
		font-size: 16px;
		color: #333;
		font-weight: bold;
	}

	.sku_table_wrap {
		margin: 20px 0;

		::v-deep .el-input-number {
			width: 100%;

			.el-input__inner {
				text-align: left;
			}
		}

		.color-cell-wrapper {
			padding: 8px 0;
			
			.color-name {
				font-weight: 500;
				margin-bottom: 5px;
				color: #333;
			}
		}
	}

	.empty_tip {
		margin: 20px 0;
	}
}

// 关联商品弹窗样式
.link_dialog_content {
	.filter_line {
		display: flex;
		align-items: center;
		gap: 20px;
		margin-bottom: 20px;

		.filter_item {
			display: flex;
			align-items: center;

			.filter_label {
				font-size: 14px;
				color: #333;
				margin-right: 10px;
				white-space: nowrap;
			}
		}
	}

	.link_product_title_row {
		margin-bottom: 20px;
		font-size: 16px;
		color: #333;
		font-weight: bold;
	}

	.link_sku_table_wrap {
		margin: 20px 0;

		.sku_name_text {
			font-weight: 500;
			color: #333;
		}
	}
}


// 复制按钮样式
.el-button--text {
	color: var(--red);
	padding: 0;
	font-size: 14px;
	cursor: pointer;

	&:hover {
		color: #ff6b6b;
		text-decoration: underline;
	}
}
</style>
<style scoped>
/*red border color*/
.el-input__inner:focus,
.el-select .el-input.is-focus .el-input__inner,
.el-select .el-input__inner:focus,
.el-radio__input.is-checked .el-radio__inner,
.el-radio__inner:hover {
	border-color: var(--red);
}

/*red color*/
.el-select-dropdown__item.selected,
.el-radio__input.is-checked + .el-radio__label {
	color: var(--red);
}

/*red background color*/
.el-radio__input.is-checked .el-radio__inner {
	background-color: var(--red);
}

.el-button {
	color: #FFFFFF;
	border:none;
}
.el-button.el-button--default {
	border: 1px solid #dddddd;
	color: #333333;
}
.table_wrap .el-table .el-table__cell{
	padding: 0;
}
</style>